import React, { FC } from "react";
import { IButtonProps } from "types/components/common/btn";
import { twMerge } from "tailwind-merge";

const OutlinedButton: FC<IButtonProps> = ({ children, className, ...rest }) => {
  return (
    <button
      className={twMerge(
        "border text-gray-700 font-semibold py-1 px-10 flex items-center gap-4 rounded-full focus:outline-none focus:shadow-outline",
        className
      )}
      type="button"
      {...rest}
    >
      {children}
    </button>
  );
};

export default OutlinedButton;
